import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const MblMenu = () => {
  const navigate = useNavigate();
  return (
    <>
      <Row className="bg-mbl sticky-bottom mx-0">
        <Col className="text-center px-0">
          <Button className="btn-mbl" onClick={() => navigate("/dashboard")}>
            <i className="fas fa-user-circle fs-1 "></i>
            <br />
            <span>Account</span>
          </Button>
        </Col>
        <Col className="text-center  px-0">
          <Button className="btn-mbl" onClick={() => navigate("/mycourses")}>
            <i className="fas fa-book-reader fs-1 "></i>
            <br />
            <span>Courses</span>
          </Button>
        </Col>
        <Col className="text-center  px-0">
          <Button className="btn-mbl" onClick={() => navigate("/mywallet")}>
            <i className="fas fa-wallet fs-1 "></i>
            <br />
            <span>Wallet</span>
          </Button>
        </Col>
        <Col className="text-center  px-0">
          <Button
            className="btn-mbl"
            onClick={() => navigate("/myassignments")}
          >
            <i className="fas fa-laptop-code fs-1 "></i>
            <br />
            <span>Assignments</span>
          </Button>
        </Col>
        <Col className="text-center  px-0">
          <Button className="btn-mbl" onClick={() => navigate("/myresume")}>
            <i className="fas fa-file-alt fs-1 "></i>
            <br />
            <span>Resume</span>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default MblMenu;
